export const DARK_WHITE = "#EED6D2";
export const LIGHT_WHITE = "#FFFFFF";
export const DARK_BLUE = "#252641";
export const LIGHT_BLUE = "#353652";
export const GREEN = "#32D55A";
export const ORANGE = "#F5AC34";
export const RED = "#ff3d7b"; // #f05857

export const colors = {
  "dark-white": DARK_WHITE,
  "light-blue": LIGHT_BLUE,
  "dark-blue": DARK_BLUE,
  "light-white": LIGHT_WHITE,
  green: GREEN,
  orange: ORANGE,
  red: RED,
  gradient: "linear-gradient(180deg, #feda04, #fc6100)",
} as const;
